/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'TaosNews',
    SITE_DESCRIPTION:
      'Search jobs in Taos, NM and find local employment opportunities with The Taos News. Your best source for Taos, NM local employers.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/taosnews',
    },
    ASSETS: {
      logo: '/static/taosnews/logo.png',
      faviconsPath: '/static/taosnews',
    },
    OG_IMAGE: '/static/taosnews/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#97bd45',
        secondary: '#2895f4',
      },
    },
    GA4_MEASUREMENT_IDS: ['G-PTGMZ2TEHT', 'G-04SBN34ERZ'],
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
  },
});
